import React, {useEffect, useState} from "react";
import ImageUploading from "react-images-uploading";
import Api from '../../../../interface/api/file';
import {FileInfo} from "../../../../interface/model/file";
export function Gallery() {

    const [ fileInfos, setFileInfos ] = useState([]);
    const [ modal , setModal ] = useState(false);

    function modalHandler() {
        setModal(!modal);
    }

    function deleteHandler(fileInfo) {
        if(window.confirm('정말 삭제하시겠습니까?')) {
            Api.deleteFileInfo(fileInfo.seq).then(res => {
                alert('정상적으로 삭제되었습니다.');
                setFileInfos(fileInfos.filter(row => row.seq !== fileInfo.seq))
            });
        }
    }

    useEffect(() => {
        Api.getFileInfo('CONTENTS').then(res => setFileInfos(res.data));
    }, [])

    return (
        <>
        <div className="nv_contents">
            <div className="nv_contents_search">
                <button type="button" className="nv_blue_button right" onClick={modalHandler}>등록</button>
            </div>
            <div className="contentsBox" style={{paddingTop: '65px'}}>
                <div className="contents_list">
                    <div className="contents_imgbox">
                        <ul>
                            {
                                fileInfos.map((row, index ) => (
                                    <li key={`fileInfoKey-${index}`}>
                                        <img src={`/upload/${row.fileCategory}/${row.saveFileName}`} alt="" width="100" />
                                        <button type="button"
                                                className="modal_close"
                                                style={{top:'10px', right:'10px'}}
                                                onClick={() => deleteHandler(row)}>X</button>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </div>
            {
                modal && <Modal closeModalHandler={modalHandler} />
            }
        </>
    )
}

export function GalleryModal({closeModalHandler, submitHandler}) {

    // const [ allClick, setAllClick] = useState(false);
    const [ fileInfos, setFileInfos ] = useState<Array<FileInfo>>([]);
    const [ selectedFileInfos, setSelectedFileInfos ] = useState<Array<FileInfo>>([]);

    function selectedHandler(fileInfo, e) {
        if(e.target.checked)
            setSelectedFileInfos(selectedFileInfos.concat(fileInfo));
        else
            setSelectedFileInfos(selectedFileInfos.filter(row => row.seq != fileInfo.seq))
    }

    function submit() {
        submitHandler(selectedFileInfos);
    }

    useEffect(() => {
        Api.getFileInfo('CONTENTS').then(res => setFileInfos(res.data));
    }, [])

    return (
        <div className="adminVersion">
            <div className="modal edu_modal on">
                <div className="modal_con" style={{background:"white"}}>
                    <div className="modal_btn_wrap">
                        <button type="button" className="modal_close" onClick={() => closeModalHandler()}>x</button>
                    </div>
                    <div className="tit" style={{paddingBottom:'20px'}}>
                        <h2 style={{color:"#333"}}>미디어 등록</h2>
                    </div>
                    <div className="contentsBox">
                        <div className="contents_list">
                            <div className="contents_imgbox" style={{
                                border: '1px solid #ddd',
                                borderRadius: '5px',
                                color: '#9c9c9c'
                            }}>
                                {/*<p>*/}
                                {/*    <input type="checkbox" id="all" onClick={() => setAllClick(!allClick)}/>*/}
                                {/*    <label htmlFor="all">전체 선택</label>*/}
                                {/*</p>*/}
                                <ul style={{ minHeight: '450px', textAlign:'left', padding:0 }}>
                                    {
                                        fileInfos.map((row, index ) => (
                                            <li key={`fileInfoKey-${index}`}>
                                                <input type="checkbox" id={`${row.seq}`} name="n" onClick={(e) => selectedHandler(row, e)}/>
                                                <label htmlFor={`${row.seq}`}>선택</label>
                                                <img src={`/upload/${row.fileCategory}/${row.saveFileName}`} alt="" width="100" />
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                            <div className="btn_area" style={{display:'block'}}>
                                <button type="button" className="nv_blue_button" onClick={submit}>확인</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function Modal({closeModalHandler}) {

    const [images, setImages] = useState([]);
    const maxNumber = 69;

    const onChange = (imageList, addUpdateIndex) => {
        // data for submit
        // console.log(imageList, addUpdateIndex);
        setImages(imageList);
    };

    function submit() {
        Api.createFileInfo(
            'CONTENTS', images.map(row=> row.file)
        ).then(res =>
            alert('정상적으로 등록되었습니다.')
        )
    }

    return (
        <div className="adminVersion">
            <div className="modal edu_modal on">
                <div className="modal_con" style={{background:"white"}}>
                    <div className="modal_btn_wrap">
                        <button type="button" className="modal_close" onClick={() => closeModalHandler()}>x</button>
                    </div>
                    <div className="tit" style={{paddingBottom:'20px'}}>
                        <h2 style={{color:"#333"}}>미디어 등록</h2>
                    </div>
                    <div className="contentsBox">
                        <div className="contents_list">
                            <div className="contents_imgbox" style={{
                                border: '1px solid #ddd',
                                borderRadius: '5px',
                                color: '#9c9c9c'
                            }}>
                                <ImageUploading
                                    multiple
                                    value={images}
                                    onChange={onChange}
                                    maxNumber={maxNumber}
                                    dataURLKey="data_url"
                                >
                                    {({
                                          imageList,
                                          onImageUpload,
                                          onImageRemoveAll,
                                          onImageUpdate,
                                          onImageRemove,
                                          isDragging,
                                          dragProps,
                                      }) => (

                                        imageList.length == 0
                                            ?   <ul className="upload__image-wrapper"
                                                    style={{ lineHeight: '10', textAlign:'center' }}
                                                    {...dragProps}
                                            >
                                                이미지를 드래그 해주세요.
                                            </ul>
                                            :   <ul className="upload__image-wrapper"
                                                    style={{ minHeight: '450px', textAlign:'left', padding:0 }}
                                                    {...dragProps}
                                            >
                                                {imageList.map((image, index) => (
                                                    <li key={index} className="image-item">
                                                        <img src={image['data_url']} alt="" width="100" />
                                                        <button type="button"
                                                                className="modal_close"
                                                                style={{top:'10px', right:'10px'}}
                                                                onClick={() => onImageRemove(index)}>X</button>
                                                    </li>
                                                ))}
                                            </ul>
                                    )}
                                </ImageUploading>
                            </div>
                            <div className="btn_area" style={{display:'block'}}>
                                <button type="button" className="nv_blue_button" onClick={submit}>업로드</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

